<template>
  <v-container>
    <barra v-bind:setbtndefault="setbuttonbarra" />
    <v-card>
      <v-card-title class="grey lighten-4 change-font" primary-title>
        <v-toolbar-title>Planes Nacionales Sectoriales</v-toolbar-title>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="d-flex">
            <span class="float-right mt-3 mt-3">{{ intro }}</span>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-card v-if="DataNacional !== null">
          <v-card-text>
            <v-layout row wrap>
              <v-flex
                v-for="item in DataNacional"
                :key="item.idnacional"
                cols="12"
                sm6
                md4
                lg3
                @click="graficapopup(item.idnacional)"
                class="sortable"
              >
                <v-flex class="black--text" style="text-align: center">{{
                  item.nombre
                }}</v-flex>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-flex v-on="on">
                      <gauge
                        :alto="110"
                        :avances="item.avances"
                        :label="true"
                      />
                    </v-flex>
                  </template>
                  <span>Detalles de {{ item.nombre }} ...</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <v-dialog v-model="dialog" width="80%">
              <v-card>
                <v-card-title>
                  {{ avancespopup.nombre }}
                </v-card-title>
                <v-card-text style="cursor: pointer">
                  <v-layout row wrap>
                    <v-flex xs12 md10 class="sortablenone">
                      <gauge
                        :alto="370"
                        :avances="avancespopup.avances"
                        trim="Avance en "
                        leyenda
                      />
                    </v-flex>
                    <v-flex xs12 md2 style="align-self: flex-end">
                      <span>Más sobre el plan:</span>

                      <router-link
                        :to="
                          'vistaciuddanodetallato/' +
                          avancespopup.idnacional 
                        "
                        :title="'Detalles de ' + avancespopup.nombre + '...'"
                      >
                        <v-icon class="pl-1 icon-05x">mdi-feature-search</v-icon
                        >Detallado
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-card-actions>
                <v-btn text color="primary" @click="dialog = false"
                  >Cerrar</v-btn
                >
              </v-card-actions>
            </v-dialog>
          </v-card-text>
        </v-card>
      </v-card-text>

      <v-card v-if="DataNacional.length > 0">
        <v-card-text style="text-align: center">
          <v-icon small :style="{ color: DataNacional[0].avances[0].color }"
            >fa-circle</v-icon
          >
          {{ DataNacional[0].avances[0].nombre }}
          <v-icon small :style="{ color: DataNacional[0].avances[1].color }"
            >fa-circle</v-icon
          >
          {{ DataNacional[0].avances[1].nombre }}
          <v-icon small :style="{ color: DataNacional[0].avances[2].color }"
            >fa-circle</v-icon
          >
          {{ DataNacional[0].avances[2].nombre }}
        </v-card-text>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import barra from "@/components/content/barra-nav.vue";
import { mapActions, mapGetters } from "vuex";
import gauge from "../../components/chart/gaugecaracol.vue";
export default {
  name: "tableroPNS",
  components: {
    barra,
    gauge,
  },
  data() {
    return {
      dialog: false,
      intro: "",
      countNacional: 0,
      setbuttonbarra: 0,
      DataNacional: [],
      avancespopup: [],
    };
  },
  methods: {
    ...mapActions(["get_listapns"]),
    SetButtons() {
      let payload = { boton: 1 };
      this.$store.dispatch("barra/setstate", payload);
      payload = { boton: 2 };
      this.$store.dispatch("barra/setstate", payload);
    },
    graficapopup(idnacional) {
      this.dialog = true;
      this.avancespopup = this.DataNacional.filter(
        (p) => p.idnacional === idnacional
      )[0];
    },
    llenarDataNacional() {
      this.DataNacional = [];
      let getperiodo = this.gperiodo;
      this.gpns.forEach((element) => {
        let pAvanceFormatI = "0,00";
        let pAvanceI = 0;
        let pAvanceFormatA = "0,00";
        let pAvanceA = 0;
        let pAvanceFormatP = "0,00";
        let pAvanceP = 0;
        if (element.avanceIndicador.length > 0) {
          let avancesindicador = element.avanceIndicador.filter(
            (p) => p.idperiodo === getperiodo
          );
          if (avancesindicador.length > 0) {
            pAvanceFormatI = avancesindicador[0].promedioAvanceFormat;
            pAvanceI = avancesindicador[0].promedioAvance;
          }
        }
        if (element.avanceactividad.length > 0) {
          let avancesactividad = element.avanceactividad.filter(
            (p) => p.idperiodo === getperiodo
          );
          if (avancesactividad.length > 0) {
            pAvanceFormatA = avancesactividad[0].promedioAvanceFormat;
            pAvanceA = avancesactividad[0].promedioAvance;
          }
        }

        if (element.avancePresupuesto.length > 0) {
          let avancespresupuesto = element.avancePresupuesto.filter(
            (p) => p.idperiodo === getperiodo
          );

          if (avancespresupuesto.length > 0) {
            pAvanceFormatP = avancespresupuesto[0].promedioAvanceFormat;
            pAvanceP = avancespresupuesto[0].promedioAvance;
          }
        }

        this.DataNacional.push({
          idnacional: element.idnacional,
          nombre: element.nombre,
          avances: [
            {
              nombre: "Avance en indicadores",
              avanceText: pAvanceFormatI,
              avance: pAvanceI,
              color: "#46c49e",
              max: 100,
            },
            {
              nombre: "Avance en actividades",
              avanceText: pAvanceFormatA,
              avance: pAvanceA,
              color: "#99D558",
              max: 100,
            },
            {
              nombre: "Avance en presupuesto",
              avanceText: pAvanceFormatP,
              avance: pAvanceP,
              color: "#0d93aa",
              max: 100,
            },
          ],
        });
      });
    },
  },
  created() {
    this.get_listapns();
    this.SetButtons();
  },
  computed: {
    ...mapGetters(["gpns"]),
    ...mapGetters("barra", ["gperiodo"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
  },
  watch: {
    gperiodo: function () {
      this.llenarDataNacional();
    },
    gpns: function () {
      this.setbuttonbarra = 3;
      this.countNacional = this.gpns.length;
      this.intro =
        "Conozca el avance de los Indicadores, las Actividades y el Presupuesto en cada uno de los " +
        this.countNacional +
        " Planes Nacionales Sectoriales:";
      if (this.gperiodo > 0 && this.DataNacional.length == 0) {
        this.llenarDataNacional();
      }
    },
  },
};
</script>

<style scoped>
.sortable {
  cursor: pointer;
}
.sortablenone {
  cursor: auto;
}
</style>